import React from "react"
import { useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"
import getAppConfig from "~/utils/getAppConfig"

import { apiSponsorshipTasks } from "~/routes"
import CatchModal from "~/library/CatchModal"
import TaskForm from "~/components/Sponsorship/TaskForm"

interface NewTaskProps {
  isOpen: boolean
  onClose: () => void
  onSuccess?: () => void
}

const NewTask: React.FC<NewTaskProps> = ({ isOpen, onClose, onSuccess }) => {
  const { venueSlug } = getAppConfig()
  const { id: sponsorshipId } = useParams<{ id: string }>()
  const toast = useToast()

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      sponsorshipId: sponsorshipId!,
      sponsorshipTask: {
        title: formValues.title,
        description: formValues.description,
        status: formValues.status,
        media_ids: formValues.media_ids || [],
      },
    }

    const req = apiSponsorshipTasks.create({ data })

    req
      .then(() => {
        toast("Task created successfully", "success")
        onSuccess?.()
        onClose()
      })
      .catch((res) => {
        toast(`${res.body?.errors?.join(", ") || "Please try again"}`, "danger")
      })
  }

  return (
    <CatchModal isOpen={isOpen} onClose={onClose} title="New Task" size="lg">
      <TaskForm onSubmit={handleSubmit} onCancel={onClose} />
    </CatchModal>
  )
}

export default NewTask
